import { getConfig } from './env';

/** The Portal group used as the MDenture production center. */
export const MDENTURE_PRODUCTION_CENTER_ID = getConfig().productionCenterId;
